import React from 'react';

import Chip from '~/components/core/Atomic/Chip/Chip';
import cn from '~/Utils/cn';

const COMPLEXITY_CHIP_CLASSNAMES: Record<string, string> = {
  low: 'bg-green-100 text-green-700',
  medium: 'bg-orange-100 text-orange-700',
  high: 'bg-red-100 text-red-700',
};

/** Colored chip for a complexity insight's level (low / medium / high). */
export const ComplexityBadge: React.FC<{ complexity: string }> = ({ complexity }) => {
  const complexityKey = complexity.toLowerCase();

  return (
    <Chip
      className={cn('h-20 rounded-full bg-blue-100 text-blue-600', COMPLEXITY_CHIP_CLASSNAMES[complexityKey])}
      label={complexity}
      size="small"
    />
  );
};
